import React from 'react'
import styled from 'styled-components'

import { StyledContainer } from '../../utils/shared-styled-components'
import TextHeader from '../../components/TextHeader'
import Button from '../../components/Button'
import CodeSnippet from '../../components/CodeSnippet'
import LanguageList from '../../components/LanguageList'
import NumberedList from '../../components/NumberedList'

const StyledWrapper = styled.div`
  padding: 88px 0;

  > header {
    padding: 0 20px;
  }
`

const StyledColumnLeft = styled.div`
  padding: 24px 0;
  width: 100%;

  ${({ theme }) => theme.media.desktop} {
    margin-top: 55px;
    max-width: 56.5%;
    min-width: 56.5%;
    order: -1;
    padding-top: 0;
    width: initial;
  }
`

const StyledColumnRight = styled.div`
  margin-bottom: 24px;

  ${({ theme }) => theme.media.desktop} {
    margin-top: 55px;
    max-width: 43, 5%;
    padding-left: 48px;
  }
`

const DeployYourMessage = ({ data: rawData, cmsData, header }) => {
  const data = (rawData.edges || rawData)[0]

  return (
    <StyledWrapper>
      <TextHeader
        mdTitle={header.title.title}
        subtitle={header.subtitleTop}
        text={header.text.text}
        theme={{ size: 'big', align: 'center' }}
      />
      <StyledContainer>
        <StyledColumnLeft>
          <CodeSnippet code={data.codeSnippet.items} />
          <LanguageList langs={data.languageStrip.items} />
        </StyledColumnLeft>
        <StyledColumnRight>
          <TextHeader
            mdTitle={cmsData[0].title.title}
            text={cmsData[0].text.text}
            theme={{ size: 'tiny', align: 'left' }}
          />
          <NumberedList items={cmsData[1].items} />
          <TextHeader
            mdTitle={cmsData[2].title.title}
            text={cmsData[2].text.text}
            theme={{ size: 'tiny', align: 'left' }}
          >
            <Button
              ghost="yes"
              to={cmsData[3].buttonLink}
              external={cmsData[3].external}
              isAbsolutePath={cmsData[3].isAbsolutePath}
            >
              {' '}
              {cmsData[3].buttonText}
            </Button>
          </TextHeader>
        </StyledColumnRight>
      </StyledContainer>
    </StyledWrapper>
  )
}

export default DeployYourMessage
